module.exports = __webpack_public_path__ + "static/img/huaxiaAL2.57ba0cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/huaxiaAL2.jpg
// module id = xzoN
// module chunks = 0